import type { LayoutType } from 'types';
import type { TranslationName } from 'types/translator';
import type { TemplateFormsState } from '../index';

interface Payload {
  layoutType: LayoutType;
  tabId: string;
  title: TranslationName[];
}

export const renameTab = (state: TemplateFormsState, { payload }: { payload: Payload }) => {
  const { layoutType, tabId, title } = payload;
  const tab = state[layoutType].tabs.find((t) => t.id === tabId);
  if (!tab) return;
  tab.titleTranslations = title;
};
